import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { supabase } from '../supabase';

const API = 'https://app.recensement-enfantsnonproteges.fr';

const TABS = ['Vous', 'Votre/ vos enfant.s', 'Parcours de garde', 'Intervention ASE', 'Démarches juridiques', 'Parcours institutionnel'];

const DEPARTEMENTS = ['01 – Ain','02 – Aisne','03 – Allier','04 – Alpes-de-Haute-Provence','05 – Hautes-Alpes','06 – Alpes-Maritimes','07 – Ardèche','08 – Ardennes','09 – Ariège','10 – Aube','11 – Aude','12 – Aveyron','13 – Bouches-du-Rhône','14 – Calvados','15 – Cantal','16 – Charente','17 – Charente-Maritime','18 – Cher','19 – Corrèze','21 – Côte-d\'Or','22 – Côtes-d\'Armor','23 – Creuse','24 – Dordogne','25 – Doubs','26 – Drôme','27 – Eure','28 – Eure-et-Loir','29 – Finistère','30 – Gard','31 – Haute-Garonne','32 – Gers','33 – Gironde','34 – Hérault','35 – Ille-et-Vilaine','36 – Indre','37 – Indre-et-Loire','38 – Isère','39 – Jura','40 – Landes','41 – Loir-et-Cher','42 – Loire','43 – Haute-Loire','44 – Loire-Atlantique','45 – Loiret','46 – Lot','47 – Lot-et-Garonne','48 – Lozère','49 – Maine-et-Loire','50 – Manche','51 – Marne','52 – Haute-Marne','53 – Mayenne','54 – Meurthe-et-Moselle','55 – Meuse','56 – Morbihan','57 – Moselle','58 – Nièvre','59 – Nord','60 – Oise','61 – Orne','62 – Pas-de-Calais','63 – Puy-de-Dôme','64 – Pyrénées-Atlantiques','65 – Hautes-Pyrénées','66 – Pyrénées-Orientales','67 – Bas-Rhin','68 – Haut-Rhin','69 – Rhône','70 – Haute-Saône','71 – Saône-et-Loire','72 – Sarthe','73 – Savoie','74 – Haute-Savoie','75 – Paris','76 – Seine-Maritime','77 – Seine-et-Marne','78 – Yvelines','79 – Deux-Sèvres','80 – Somme','81 – Tarn','82 – Tarn-et-Garonne','83 – Var','84 – Vaucluse','85 – Vendée','86 – Vienne','87 – Haute-Vienne','88 – Vosges','89 – Yonne','90 – Territoire de Belfort','91 – Essonne','92 – Hauts-de-Seine','93 – Seine-Saint-Denis','94 – Val-de-Marne','95 – Val-d\'Oise','971 – Guadeloupe','972 – Martinique','973 – Guyane','974 – La Réunion','976 – Mayotte'];

const DROITS_OPTIONS = ['GARDE ALTERNÉE','GARDE PRINCIPALE','GARDE EXCLUSIVE','DROITS DE VISITES','PLACEMENT J.E CHEZ PARENT PROTECTEUR','DROITS DE VISITES SANS HÉBERGEMENT','VISITES MÉDIATISÉES','APPELS TÉLÉPHONIQUES UNIQUEMENT','AUCUN APPEL NI VISITE'];
const AVEC_OPTIONS = ['RÉSERVE DES DROITS D\'HÉBERGEMENT','DROITS DE VISITES SANS HÉBERGEMENT','A.E.M.O','M.I.J.E'];
const GARDE_OPTIONS = ['GARDE ALTERNÉE','GARDE PRINCIPALE','GARDE EXCLUSIVE','DROITS DE VISITES','PLACEMENT J.E CHEZ PARENT PROTECTEUR','DROITS DE VISITES SANS HÉBERGEMENT','VISITES MÉDIATISÉES','APPELS TÉLÉPHONIQUES UNIQUEMENT','AUCUN APPEL NI VISITE'];
const VIOLENCES_ENFANTS = ['VIOLS','AGRESSION SEXUELLES','VIOLENCES PHYSIQUES','VIOLENCES PSYCHOLOGIQUES (Contrôle coercitif, abus psychologiques, insultes...)','NÉGLIGENCES & PRIVATIONS','VIOLENCES INSTITUTIONNELLES','PLACEMENT ASE ILLÉGAL','PROSTITUTION VIA L\'ASE'];
const VIOLENCES_PP = ['VIOLS','AGRESSION SEXUELLES','VIOLENCES PHYSIQUES','VIOLENCES PSYCHOLOGIQUES (Contrôle coercitif, abus psychologiques, insultes...)','VIOLENCES INSTITUTIONNELLES','VIOLENCES ÉCONOMIQUES (Rétention, irrégularités de la pension alimentaire...)','INERTIE (Opposition ou absence de réponse/ engagement financier concernant la santé, les études, les frais exceptionnels pour l\'enfant)'];
const MONTANTS_PENSION = ['Aucune','- de 140 €','140 - 150 €','150 - 200 €','200 - 250 €','250 - 300 €','300 - 350 €','350 - 400 €','400 - 450 €','450 - 550 €','500 - 600 €','+ de 600 €'];
const SALAIRES = ['- de 1 200 €','1 200 - 1 400 €','1 400 - 1 600 €','1 600 - 1 800 €','1 800 - 2 000 €','2 000 - 2 200€','2 200 - 2 400 €','2 400 - 2 600 €','2 600 - 2 800 €','2 800 - 3 000 €','3 000 - 3 500 €','3 500 - 4 000 €','4 000 - 4 500 €','4 500 - 5 000 €','5 500 - 6 000 €','6 000 - 6 500 €','6 500 - 7 000 €','7 000 - 7 500 €','7 500 - 8 000 €','8 000 - 8 500 €','+ de 8000 €','Inconnu'];
const MESURES_ASE = ['A.E.M.O','M.I.J.E','AED','ENQUÊTE ASE'];
const ETAPES_PROCEDURE = ['1ERE INSTANCE','APPEL','CASSATION','CEDH'];

const s = {
  wrap: {background:'#F1F1F7',minHeight:'100vh',padding:'24px',fontFamily:'-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif'},
  modal: {background:'#fff',borderRadius:'16px',maxWidth:'760px',margin:'0 auto',boxShadow:'0 8px 40px rgba(0,0,0,0.12)',overflow:'hidden'},
  header: {padding:'24px 28px 16px',textAlign:'center',borderBottom:'1px solid #eee',position:'relative'},
  title: {fontSize:'22px',fontWeight:'700',color:'#19232F',marginBottom:'6px'},
  sub: {fontSize:'12px',color:'#888',lineHeight:'1.6'},
  anon: {background:'#E3E8F7',borderRadius:'10px',padding:'14px 18px',margin:'16px 24px 0',display:'flex',alignItems:'flex-start',justifyContent:'space-between',gap:'12px',cursor:'pointer'},
  anonText: {fontSize:'12px',color:'#19232F',lineHeight:'1.6'},
  tabs: {display:'flex',borderBottom:'2px solid #eee',padding:'0 28px',marginTop:'16px',overflowX:'auto',gap:'0'},
  tab: {padding:'12px 16px',fontSize:'13px',fontWeight:'500',color:'#aaa',cursor:'pointer',borderBottom:'2px solid transparent',whiteSpace:'nowrap',marginBottom:'-2px'},
  tabActive: {padding:'12px 16px',fontSize:'13px',fontWeight:'700',color:'#065FD3',cursor:'pointer',borderBottom:'2px solid #065FD3',whiteSpace:'nowrap',marginBottom:'-2px'},
  body: {padding:'28px'},
  sectionTitle: {fontSize:'24px',fontWeight:'800',color:'#19232F',marginBottom:'6px'},
  sectionSub: {fontSize:'13px',color:'#555',marginBottom:'6px'},
  sectionSub2: {fontSize:'13px',color:'#555',marginBottom:'24px'},
  card: {border:'1px solid #e4e4ee',borderRadius:'14px',padding:'24px',marginBottom:'16px',background:'#fff'},
  cardTitle: {fontSize:'15px',fontWeight:'700',color:'#19232F',marginBottom:'20px'},
  blockLabel: {fontSize:'13px',fontWeight:'700',color:'#19232F',marginBottom:'14px'},
  blockLabelMt: {fontSize:'13px',fontWeight:'700',color:'#19232F',margin:'22px 0 14px'},
  fieldLabel: {fontSize:'12px',color:'#666',display:'block',marginBottom:'6px',fontWeight:'500'},
  input: {width:'100%',border:'1px solid #ddd',borderRadius:'8px',padding:'9px 13px',fontSize:'13px',color:'#19232F',fontFamily:'inherit'},
  select: {width:'100%',border:'1px solid #ddd',borderRadius:'8px',padding:'9px 13px',fontSize:'13px',color:'#19232F',fontFamily:'inherit',background:'#fff'},
  radioCard: (sel) => ({border:`1px solid ${sel?'#065FD3':'#ddd'}`,borderRadius:'10px',padding:'12px 10px',cursor:'pointer',display:'flex',flexDirection:'column',alignItems:'flex-start',gap:'8px',background:sel?'#EEF4FF':'#fff'}),
  radioCardText: {fontSize:'11px',fontWeight:'600',color:'#19232F',lineHeight:'1.3'},
  checkCard: (sel) => ({border:`1px solid ${sel?'#065FD3':'#ddd'}`,borderRadius:'10px',padding:'12px 10px',cursor:'pointer',display:'flex',flexDirection:'column',alignItems:'flex-start',gap:'8px',background:sel?'#EEF4FF':'#fff'}),
  ri: (sel) => ({border:`1px solid ${sel?'#065FD3':'#ddd'}`,borderRadius:'8px',padding:'9px 18px',cursor:'pointer',display:'flex',alignItems:'center',gap:'8px',fontSize:'13px',color:sel?'#065FD3':'#19232F',fontWeight:'500',background:sel?'#EEF4FF':'#fff'}),
  penItem: (sel) => ({border:`1px solid ${sel?'#065FD3':'#ddd'}`,borderRadius:'8px',padding:'9px 8px',fontSize:'12px',color:sel?'#065FD3':'#19232F',cursor:'pointer',display:'flex',alignItems:'center',gap:'6px',background:sel?'#EEF4FF':'#fff'}),
  saveBtn: {display:'block',margin:'28px auto 0',background:'#065FD3',color:'#fff',border:'none',borderRadius:'8px',padding:'12px 40px',fontSize:'13px',fontWeight:'700',cursor:'pointer',textTransform:'uppercase',letterSpacing:'0.06em'},
  navRow: {display:'flex',justifyContent:'space-between',alignItems:'center',marginTop:'24px',paddingTop:'20px',borderTop:'1px solid #eee'},
  navBtn: {border:'1px solid #ddd',borderRadius:'8px',padding:'8px 16px',fontSize:'12px',color:'#19232F',cursor:'pointer',background:'#fff',fontWeight:'500'},
  navBtnNext: {border:'1px solid #ddd',borderRadius:'8px',padding:'8px 16px',fontSize:'12px',color:'#19232F',cursor:'pointer',background:'#fff',fontWeight:'500'},
  expand: {border:'1px solid #ddd',borderRadius:'10px',padding:'16px 20px',marginBottom:'12px',display:'flex',alignItems:'center',justifyContent:'space-between',cursor:'pointer',fontSize:'14px',color:'#19232F',fontWeight:'500'},
  footer: {borderTop:'1px solid #eee',padding:'16px 28px',display:'flex',alignItems:'center',justifyContent:'space-between'},
  footerText: {fontSize:'13px',color:'#888'},
  footerBtn: {border:'1px solid #065FD3',borderRadius:'8px',padding:'8px 16px',fontSize:'12px',color:'#065FD3',cursor:'pointer',background:'#fff',fontWeight:'600'},
  infoBox: {background:'#EAEEF8',borderRadius:'10px',padding:'20px',marginTop:'20px'},
  infoTitle: {fontSize:'14px',fontWeight:'700',color:'#19232F',marginBottom:'12px'},
  infoItem: {fontSize:'13px',color:'#555',lineHeight:'1.7'},
};

const RadioGroup = ({ options, value, onChange, name }) => (
  <div style={{display:'flex',gap:'10px',flexWrap:'wrap'}}>
    {options.map(o => (
      <div key={o} style={s.ri(value===o)} onClick={() => onChange(o)}>
        <input type="radio" name={name} checked={value===o} onChange={() => onChange(o)} style={{accentColor:'#065FD3'}} readOnly />
        {o}
      </div>
    ))}
  </div>
);

const CheckGrid = ({ options, values, onChange, cols=4 }) => (
  <div style={{display:'grid',gridTemplateColumns:`repeat(${cols},1fr)`,gap:'10px',marginBottom:'14px'}}>
    {options.map(o => {
      const sel = values.includes(o);
      return (
        <div key={o} style={s.checkCard(sel)} onClick={() => onChange(sel ? values.filter(v=>v!==o) : [...values,o])}>
          <input type="checkbox" checked={sel} onChange={()=>{}} style={{accentColor:'#065FD3'}} />
          <span style={s.radioCardText}>{o}</span>
        </div>
      );
    })}
  </div>
);

const RadioGrid = ({ options, value, onChange, name, cols=4 }) => (
  <div style={{display:'grid',gridTemplateColumns:`repeat(${cols},1fr)`,gap:'10px',marginBottom:'20px'}}>
    {options.map(o => {
      const sel = value===o;
      return (
        <div key={o} style={s.radioCard(sel)} onClick={() => onChange(o)}>
          <input type="radio" name={name} checked={sel} onChange={()=>{}} style={{accentColor:'#065FD3'}} />
          <span style={s.radioCardText}>{o}</span>
        </div>
      );
    })}
  </div>
);

const newEnfant = () => ({ pseudo:'', annee:'', placement:'Chez vous (parent protecteur)', droits:[], avec:[], autorite:'CONJOINTE', pension_qui:'Vous (maman)', pension_maj:true, pension_montant:'Aucune', pension_montant_libre:'', pension_percue:'Oui', salaire:'' });
const newGarde = () => ({ date_debut:'', danger_immediat:false, placement_ase:false, tous_enfants:true, garde_pp:'', garde_pp_avec:[], garde_agresseur:'', garde_agresseur_avec:[], showViolences:false, violences_enfants:[], depot_plainte_enfants:true, date_revelations:'', violences_pp:[], depot_plainte_pp:true, date_revelations_pp:'', commentaire:'', showCommentaire:false });
const newAse = () => ({ mesure_en_cours:false, date_debut:'', date_fin:'', danger_immediat:false, tous_enfants:true, mesures:'', commentaire:'', showCommentaire:false });
const newDemarche = () => ({ na_pas_pu:[], procedure_en_cours:false, date_procedure:'', nom_tribunal:'', departement:'', nb_fois:'1', etape:'1ERE INSTANCE', avocat_deconseille:[], initiative:'Moi même' });

export default function Formulaire({ onBack, onNavigate }) {
  const [tab, setTab] = useState(0);
  const [anonOpen, setAnonOpen] = useState(false);
  const [saving, setSaving] = useState(false);
  const [saveMsg, setSaveMsg] = useState('');
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);
  const [submitted, setSubmitted] = useState(false);

  const [vous, setVous] = useState({ pseudo:'', tel:'', email:'', benevole:'Oui' });
  const [enfants, setEnfants] = useState([newEnfant()]);
  const [gardes, setGardes] = useState([newGarde()]);
  const [ases, setAses] = useState([newAse()]);
  const [demarches, setDemarches] = useState([newDemarche()]);

  const isLoggedIn = !!user;

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      if (session?.user) { setUser(session.user); setToken(session.access_token); }
    });
  }, []);

  const setEnfant = (i, k, v) => setEnfants(e => e.map((en, idx) => idx===i ? {...en,[k]:v} : en));
  const setGarde = (i, k, v) => setGardes(g => g.map((gr, idx) => idx===i ? {...gr,[k]:v} : gr));
  const setAse = (i, k, v) => setAses(a => a.map((as, idx) => idx===i ? {...as,[k]:v} : as));
  const setDemarche = (i, k, v) => setDemarches(d => d.map((de, idx) => idx===i ? {...de,[k]:v} : de));

  const save = async () => {
    setSaving(true); setSaveMsg('');
    try {
      const payload = { pp_pseudo: vous.pseudo, pp_tel: vous.tel, pp_email: vous.email, pp_benevole: vous.benevole==='Oui', est_brouillon: true, statut: 'brouillon', visible: false, supabase_user_id: user?.id, enfants, gardes, ases, demarches };
      await axios.post(API+'/api/fiches/draft', payload, { headers:{Authorization:'Bearer '+token} });
      setSaveMsg('✓ Sauvegardé');
      setTimeout(() => setSaveMsg(''), 3000);
    } catch(e) { setSaveMsg('Erreur'); }
    setSaving(false);
  };

  const submit = async () => {
    setSaving(true);
    try {
      const payload = { pp_pseudo: vous.pseudo, pp_tel: vous.tel, pp_email: vous.email, pp_benevole: vous.benevole==='Oui', est_brouillon: false, statut: 'en_attente', visible: false, supabase_user_id: user?.id, enfants, gardes, ases, demarches };
      await axios.post(API+'/api/fiches', payload);
      setSubmitted(true);
    } catch(e) { setSaveMsg("Erreur lors de l'envoi."); }
    setSaving(false);
  };

  if (submitted) return (
    <div style={s.wrap}>
      <div style={{...s.modal,textAlign:'center',padding:'60px 40px'}}>
        <div style={{fontSize:'48px',marginBottom:'16px'}}>✓</div>
        <h2 style={{fontSize:'22px',fontWeight:'800',color:'#19232F',marginBottom:'12px'}}>Fiche envoyée</h2>
        <p style={{color:'#666',lineHeight:'1.7',marginBottom:'8px'}}>Votre contribution sera <strong>publiée après relecture de notre équipe bénévole.</strong></p>
        <p style={{color:'#666',lineHeight:'1.7',marginBottom:'24px'}}>Prévoyez <strong>48 à 72h</strong> avant notre retour par mail.</p>
        <button style={s.saveBtn} onClick={onBack}>Retour</button>
      </div>
    </div>
  );

  return (
    <div style={s.wrap}>
      <div style={s.modal}>
        <div style={s.header}>
          <div style={s.title}>Renseigner <span style={{color:'#6558F4'}}>sa fiche</span></div>
          <div style={s.sub}>Vérifiez bien votre connexion et le niveau de batterie de votre appareil avant de commencer,<br/>sans compte utilisatrice aucune fiche en cours ne pourra être sauvegardée.</div>
          <button style={{position:'absolute',top:'20px',right:'24px',background:'none',border:'none',fontSize:'20px',color:'#bbb',cursor:'pointer'}} onClick={onBack}>✕</button>
        </div>

        <div style={s.anon} onClick={() => setAnonOpen(!anonOpen)}>
          <div style={s.anonText}>
            Pour garantir la recevabilité de votre contribution, <strong>anonymisez en utilisant uniquement les initiales tous les noms</strong> dans :
            {anonOpen && (
              <div style={{marginTop:'10px'}}>
                <ol style={{paddingLeft:'16px',fontSize:'12px',lineHeight:'1.8'}}>
                  <li>vos réponses</li><li>remarques</li><li>champs libres (y compris agresseur ou agresseur présumé)</li>
                </ol>
                <p style={{marginTop:'12px',fontSize:'12px',lineHeight:'1.6',color:'#444'}}>Votre contribution sera publiée après relecture de notre équipe bénévole. Prévoyez 48 à 72h.</p>
              </div>
            )}
          </div>
          <div style={{color:'#6558F4',fontSize:'18px',flexShrink:0}}>{anonOpen ? '∧' : '∨'}</div>
        </div>

        <div style={s.tabs}>
          {TABS.map((t,i) => (
            <div key={i}
              style={i===tab ? s.tabActive : {...s.tab, opacity: !isLoggedIn && i > 0 ? 0.35 : 1, cursor: !isLoggedIn && i > 0 ? 'not-allowed' : 'pointer'}}
              onClick={() => { if (!isLoggedIn && i > 0) return; setTab(i); }}
            >{t}</div>
          ))}
        </div>

        <div style={s.body}>

          {/* ===== ONGLET 1 : VOUS ===== */}
          {tab===0 && (
            <>
              <div style={s.sectionTitle}>Parent <span style={{color:'#6558F4'}}>protecteur</span></div>
              <div style={{...s.sectionSub,fontWeight:'700',color:'#065FD3',marginBottom:'4px'}}>À tout moment, nous protégeons votre identité et celle des enfants.</div>
              <div style={{...s.sectionSub,fontWeight:'700',color:'#19232F',marginBottom:'8px'}}>Vos informations personnelles sont stockées séparément de la fiche publique.</div>
              <div style={{...s.sectionSub,marginBottom:'24px'}}>Tous ces champs sont obligatoires.</div>

              <div style={s.card}>
                <div style={{display:'grid',gridTemplateColumns:'1fr 1fr 1fr',gap:'16px',marginBottom:'24px'}}>
                  <div><label style={s.fieldLabel}>Choisissez un pseudo</label><input style={s.input} placeholder="SuperMaman" value={vous.pseudo} onChange={e=>setVous(v=>({...v,pseudo:e.target.value}))} /></div>
                  <div><label style={s.fieldLabel}>Téléphone <span style={{color:'#aaa',fontSize:'11px'}}>(crypté)</span></label><input style={s.input} placeholder="06XXXXXXXXX" value={vous.tel} onChange={e=>setVous(v=>({...v,tel:e.target.value}))} /></div>
                  <div><label style={s.fieldLabel}>Email <span style={{color:'#aaa',fontSize:'11px'}}>(crypté)</span></label><input style={s.input} placeholder="votre@email.fr" value={vous.email} onChange={e=>setVous(v=>({...v,email:e.target.value}))} /></div>
                </div>
                <div style={s.blockLabel}>Je souhaite rejoindre l'équipe bénévole du Recensement des enfants non-protégés.</div>
                <RadioGroup options={['Oui','Non']} value={vous.benevole} onChange={v=>setVous(vv=>({...vv,benevole:v}))} name="benevole" />
              </div>

              <div style={s.infoBox}>
                <div style={s.infoTitle}>Comment <span style={{color:'#065FD3'}}>nous protégeons votre identité</span> ?</div>
                {["En vous proposant d'utiliser des pseudos","En cryptant les données sur notre serveur propriétaire","Nous bénéficions des mêmes mesures de cybersécurité que le site classé sans suite."].map((t,i) => (
                  <div key={i} style={{...s.infoItem,marginBottom:'6px'}}>· {t}</div>
                ))}
              </div>

              {!isLoggedIn && (
                <div style={{textAlign:'center',marginTop:'28px',padding:'24px',background:'#E3E8F7',borderRadius:'12px'}}>
                  <div style={{fontSize:'15px',fontWeight:'700',color:'#19232F',marginBottom:'8px'}}>Créez votre compte pour remplir et soumettre votre fiche</div>
                  <div style={{fontSize:'13px',color:'#666',marginBottom:'16px'}}>Les étapes suivantes ne sont accessibles qu'aux utilisatrices connectées.</div>
                  <button style={{...s.saveBtn,marginTop:0}} onClick={onNavigate}>CRÉER MON COMPTE →</button>
                </div>
              )}
            </>
          )}

          {/* ===== ONGLET 2 : ENFANTS ===== */}
          {tab===1 && (
            <>
              <div style={s.sectionTitle}>Votre/ vos <span style={{color:'#6558F4'}}>enfant.s</span></div>
              <div style={{...s.sectionSub,fontWeight:'700',marginBottom:'4px'}}>Les noms et prénoms des enfants ne sont jamais affichés publiquement.</div>
              <div style={s.sectionSub2}>La garde évolue dans le temps, renseignez chaque période avec les violences potentielles et les organismes ayant intervenus.</div>

              {enfants.map((en, i) => (
                <div key={i} style={s.card}>
                  <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:'20px'}}>
                    <div style={s.cardTitle}>Enfant {i+1}</div>
                    {i>0 && <button onClick={()=>setEnfants(e=>e.filter((_,idx)=>idx!==i))} style={{background:'none',border:'none',color:'#aaa',cursor:'pointer',fontSize:'18px'}}>🗑</button>}
                  </div>
                  <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'16px',marginBottom:'22px'}}>
                    <div><label style={s.fieldLabel}>Choisissez un pseudo</label><input style={s.input} placeholder="Super enfant" value={en.pseudo} onChange={e=>setEnfant(i,'pseudo',e.target.value)} /></div>
                    <div><label style={s.fieldLabel}>Année de naissance</label><input style={s.input} placeholder="yyyy" value={en.annee} onChange={e=>setEnfant(i,'annee',e.target.value)} /></div>
                  </div>

                  <div style={s.blockLabel}>Votre enfant est placé</div>
                  <RadioGrid options={['Chez vous (parent protecteur)','Chez le parent présumé agresseur','Chez un membre de la famille','Autre (Si A.S.E, volet dédié)']} value={en.placement} onChange={v=>setEnfant(i,'placement',v)} name={`place${i}`} />

                  <div style={s.blockLabel}>Concernant vos droits</div>
                  <CheckGrid options={DROITS_OPTIONS} values={en.droits} onChange={v=>setEnfant(i,'droits',v)} cols={4} />

                  <div style={{...s.blockLabel,marginTop:'8px'}}>Avec</div>
                  <CheckGrid options={AVEC_OPTIONS} values={en.avec||[]} onChange={v=>setEnfant(i,'avec',v)} cols={4} />

                  <div style={s.blockLabelMt}>Concernant votre autorité parentale actuelle</div>
                  <RadioGroup options={['CONJOINTE','SUSPENDUE','PERDUE']} value={en.autorite} onChange={v=>setEnfant(i,'autorite',v)} name={`aut${i}`} />

                  <div style={{...s.card,marginTop:'20px',background:'#FAFAFE'}}>
                    <div style={s.cardTitle}>Pension alimentaire actuelle</div>
                    <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'20px',marginBottom:'22px'}}>
                      <div>
                        <div style={s.blockLabel}>Actuellement, qui doit payer la pension alimentaire ?</div>
                        <RadioGroup options={['Vous (maman)','Le père']} value={en.pension_qui} onChange={v=>setEnfant(i,'pension_qui',v)} name={`pqui${i}`} />
                      </div>
                      <div>
                        <div style={s.blockLabel}>Chaque année, cette pension alimentaire est elle mise à jour ?</div>
                        <RadioGroup options={['Oui','Non']} value={en.pension_maj?'Oui':'Non'} onChange={v=>setEnfant(i,'pension_maj',v==='Oui')} name={`pmaj${i}`} />
                      </div>
                    </div>

                    <div style={s.blockLabel}>Pension alimentaire mensuelle <span style={{color:'#065FD3'}}>ordonnée par enfant</span></div>
                    <div style={{fontSize:'12px',color:'#aaa',marginBottom:'12px'}}>(choisissez la valeur la plus proche)</div>
                    <div style={{display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:'8px',marginBottom:'22px'}}>
                      {MONTANTS_PENSION.map(m => (
                        <div key={m} style={s.penItem(en.pension_montant===m)} onClick={()=>setEnfant(i,'pension_montant',m)}>
                          <input type="radio" checked={en.pension_montant===m} onChange={()=>{}} style={{accentColor:'#065FD3'}} />{m}
                        </div>
                      ))}
                    </div>
                    {en.pension_montant==='+  de 600 €' && (
                      <input style={{...s.input,marginBottom:'14px'}} placeholder="Renseignez le montant approximatif en €" value={en.pension_montant_libre||''} onChange={e=>setEnfant(i,'pension_montant_libre',e.target.value)} />
                    )}

                    <div style={{...s.blockLabel,marginBottom:'14px'}}>La pension alimentaire est-elle <span style={{color:'#6558F4'}}>perçue ?</span></div>
                    <RadioGroup options={['Oui','Partiellement','Non']} value={en.pension_percue} onChange={v=>setEnfant(i,'pension_percue',v)} name={`pperc${i}`} />

                    <div style={{...s.blockLabel,marginTop:'20px'}}>Salaire mensuel du <span style={{color:'#065FD3'}}>parent redevable de la pension</span></div>
                    <div style={{fontSize:'12px',color:'#aaa',marginBottom:'12px'}}>(choisissez la valeur la plus proche)</div>
                    <div style={{display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:'8px'}}>
                      {SALAIRES.map(m => (
                        <div key={m} style={s.penItem(en.salaire===m)} onClick={()=>setEnfant(i,'salaire',m)}>
                          <input type="radio" checked={en.salaire===m} onChange={()=>{}} style={{accentColor:'#065FD3'}} />{m}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              ))}
              <div style={s.expand} onClick={()=>setEnfants(e=>[...e,newEnfant()])}>
                Ajouter un enfant <span style={{color:'#065FD3',fontSize:'20px'}}>+</span>
              </div>
              <div style={s.expand}>
                Ajouter une pension <span style={{fontSize:'11px',color:'#aaa',fontWeight:'400'}}>(si pension différente du premier enfant renseigné)</span>
                <span style={{color:'#065FD3',fontSize:'20px'}}>+</span>
              </div>
            </>
          )}

          {/* ===== ONGLET 3 : PARCOURS DE GARDE ===== */}
          {tab===2 && (
            <>
              <div style={s.sectionTitle}>Parcours de <span style={{color:'#6558F4'}}>garde</span></div>
              <div style={{...s.sectionSub,fontWeight:'700',marginBottom:'4px'}}>Les noms et prénoms des enfants ne sont jamais affichés publiquement.</div>
              <div style={s.sectionSub2}>La garde évolue dans le temps, renseignez chaque période avec les violences potentielles et les organismes ayant intervenus.</div>

              {gardes.map((g, i) => (
                <div key={i}>
                  <div style={s.card}>
                    <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:'20px'}}>
                      <div><span style={{...s.cardTitle,marginBottom:0}}>Période {i+1}</span><span style={{fontSize:'12px',color:'#aaa',marginLeft:'8px'}}>· de la situation actuelle à la plus ancienne</span></div>
                      {i>0 && <button onClick={()=>setGardes(g=>g.filter((_,idx)=>idx!==i))} style={{background:'none',border:'none',color:'#aaa',cursor:'pointer',fontSize:'18px'}}>🗑</button>}
                    </div>

                    <div style={{display:'grid',gridTemplateColumns:'1fr 1fr 1fr',gap:'16px',marginBottom:'20px'}}>
                      <div><label style={s.fieldLabel}>Date de début</label><input type="date" style={s.input} value={g.date_debut} onChange={e=>setGarde(i,'date_debut',e.target.value)} /></div>
                      <div>
                        <div style={s.fieldLabel}>Danger immédiat <span style={{color:'#aaa',fontSize:'11px'}}>(VSS, VP et psychologique ...)</span></div>
                        <RadioGroup options={['Oui','Non']} value={g.danger_immediat?'Oui':'Non'} onChange={v=>setGarde(i,'danger_immediat',v==='Oui')} name={`di${i}`} />
                      </div>
                      <div>
                        <div style={s.fieldLabel}>Placement ASE</div>
                        <RadioGroup options={['Oui','Non']} value={g.placement_ase?'Oui':'Non'} onChange={v=>setGarde(i,'placement_ase',v==='Oui')} name={`pase${i}`} />
                      </div>
                    </div>

                    <div style={{...s.blockLabel,marginBottom:'10px'}}>Si j'ai plusieurs enfants, cette situation concerne ….</div>
                    <RadioGroup options={['Tous mes enfants','Une partie de mes enfants']} value={g.tous_enfants?'Tous mes enfants':'Une partie de mes enfants'} onChange={v=>setGarde(i,'tous_enfants',v==='Tous mes enfants')} name={`te${i}`} />
                    {!g.tous_enfants && <div style={{fontSize:'11px',color:'#aaa',marginBottom:'12px'}}>(remplissez une période par enfant si modes de garde différents)</div>}

                    <div style={s.blockLabel}>Garde - Parent protecteur <span style={{color:'#aaa',fontSize:'12px',fontWeight:'400'}}>· Vous</span></div>
                    <RadioGrid options={GARDE_OPTIONS} value={g.garde_pp} onChange={v=>setGarde(i,'garde_pp',v)} name={`gpp${i}`} cols={4} />
                    <div style={{...s.blockLabel,fontSize:'12px',color:'#888',fontWeight:'500',marginBottom:'8px'}}>Avec</div>
                    <CheckGrid options={AVEC_OPTIONS} values={g.garde_pp_avec||[]} onChange={v=>setGarde(i,'garde_pp_avec',v)} cols={4} />

                    <div style={{...s.blockLabel,marginTop:'8px'}}>Garde - Agresseur présumé <span style={{color:'#aaa',fontSize:'12px',fontWeight:'400'}}>· Lui</span></div>
                    <RadioGrid options={GARDE_OPTIONS} value={g.garde_agresseur} onChange={v=>setGarde(i,'garde_agresseur',v)} name={`gag${i}`} cols={4} />
                    <div style={{...s.blockLabel,fontSize:'12px',color:'#888',fontWeight:'500',marginBottom:'8px'}}>Avec</div>
                    <CheckGrid options={AVEC_OPTIONS} values={g.garde_agresseur_avec||[]} onChange={v=>setGarde(i,'garde_agresseur_avec',v)} cols={4} />
                  </div>

                  {/* VIOLENCES — toujours visible si danger immédiat, sinon expandable */}
                  {g.danger_immediat ? (
                    <div style={s.card}>
                      <div style={s.cardTitle}>Violences subies <span style={{fontSize:'12px',color:'#aaa',fontWeight:'400'}}>· de la situation actuelle à la plus ancienne</span></div>
                      <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'16px',marginBottom:'16px'}}>
                        <div><label style={s.fieldLabel}>Date de début</label><input type="date" style={s.input} value={g.date_debut} onChange={e=>setGarde(i,'date_debut',e.target.value)} /></div>
                        <div>
                          <div style={s.fieldLabel}>Danger immédiat <span style={{color:'#aaa',fontSize:'11px'}}>(VSS, VP et psychologique ...)</span></div>
                          <RadioGroup options={['Oui','Non']} value={g.danger_immediat?'Oui':'Non'} onChange={v=>setGarde(i,'danger_immediat',v==='Oui')} name={`div${i}`} />
                        </div>
                      </div>
                      <div style={{...s.blockLabel,marginBottom:'10px'}}>Si j'ai plusieurs enfants, cette situation concerne ….</div>
                      <RadioGroup options={['Tous mes enfants','Une partie de mes enfants']} value={g.tous_enfants?'Tous mes enfants':'Une partie de mes enfants'} onChange={v=>setGarde(i,'tous_enfants',v==='Tous mes enfants')} name={`tev${i}`} />
                      <ViolencesBlock g={g} i={i} setGarde={setGarde} />
                    </div>
                  ) : (
                    <>
                      <div style={s.expand} onClick={()=>setGarde(i,'showViolences',!g.showViolences)}>
                        Ajouter des violences <span style={{color:'#065FD3',fontSize:'20px'}}>+</span>
                      </div>
                      {g.showViolences && (
                        <div style={s.card}>
                          <ViolencesBlock g={g} i={i} setGarde={setGarde} />
                        </div>
                      )}
                    </>
                  )}
                </div>
              ))}

              <div style={s.expand} onClick={()=>setGardes(g=>[...g,newGarde()])}>
                Ajouter une période de garde <span style={{color:'#065FD3',fontSize:'20px'}}>+</span>
              </div>
              <div style={s.expand} onClick={()=>setGardes(g=>g.map((gr,idx)=>idx===gardes.length-1?{...gr,showCommentaire:!gr.showCommentaire}:gr))}>
                Ajouter un commentaire <span style={{color:'#065FD3',fontSize:'20px'}}>+</span>
              </div>
            </>
          )}

          {/* ===== ONGLET 4 : INTERVENTION ASE ===== */}
          {tab===3 && (
            <>
              <div style={s.sectionTitle}>Intervention <span style={{color:'#6558F4'}}>ASE</span></div>
              <div style={{...s.sectionSub,fontWeight:'700',marginBottom:'4px'}}>Hors mesure de placement.</div>
              <div style={s.sectionSub2}>Renseignez les différentes interventions de l'ASE ordonnées par décisions judiciaires ou administratives.</div>

              {ases.map((a, i) => (
                <div key={i} style={s.card}>
                  <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:'20px'}}>
                    <div><span style={s.cardTitle}>Période {i+1}</span><span style={{fontSize:'12px',color:'#aaa',marginLeft:'8px'}}>· de l'intervention actuelle à la plus ancienne</span></div>
                    {i>0 && <button onClick={()=>setAses(as=>as.filter((_,idx)=>idx!==i))} style={{background:'none',border:'none',color:'#aaa',cursor:'pointer',fontSize:'18px'}}>🗑</button>}
                  </div>

                  <div style={{display:'grid',gridTemplateColumns:'1fr 1fr 1fr',gap:'16px',marginBottom:'20px'}}>
                    <div>
                      <div style={s.fieldLabel}>Mesure en cours</div>
                      <RadioGroup options={['Oui','Non']} value={a.mesure_en_cours?'Oui':'Non'} onChange={v=>setAse(i,'mesure_en_cours',v==='Oui')} name={`ase_mc${i}`} />
                    </div>
                    <div><label style={s.fieldLabel}>Date de début</label><input type="date" style={s.input} value={a.date_debut} onChange={e=>setAse(i,'date_debut',e.target.value)} /></div>
                    <div><label style={s.fieldLabel}>Date de fin</label><input type="date" style={s.input} value={a.date_fin} onChange={e=>setAse(i,'date_fin',e.target.value)} /></div>
                  </div>

                  <div style={{marginBottom:'16px'}}>
                    <div style={s.fieldLabel}>Danger immédiat <span style={{color:'#aaa',fontSize:'11px'}}>(VSS, VP et psychologique ...)</span></div>
                    <RadioGroup options={['Oui','Non']} value={a.danger_immediat?'Oui':'Non'} onChange={v=>setAse(i,'danger_immediat',v==='Oui')} name={`ase_di${i}`} />
                  </div>

                  <div style={{marginBottom:'16px'}}>
                    <div style={s.blockLabel}>Si j'ai plusieurs enfants, cette organisation concerne ….</div>
                    <RadioGroup options={['Tous mes enfants','Une partie de mes enfants']} value={a.tous_enfants?'Tous mes enfants':'Une partie de mes enfants'} onChange={v=>setAse(i,'tous_enfants',v==='Tous mes enfants')} name={`ase_te${i}`} />
                  </div>

                  <div style={s.blockLabel}>Mesures judiciaires prononcées</div>
                  <RadioGrid options={MESURES_ASE} value={a.mesures} onChange={v=>setAse(i,'mesures',v)} name={`ase_m${i}`} cols={4} />
                </div>
              ))}

              <div style={s.expand} onClick={()=>setAses(a=>[...a,newAse()])}>
                Ajouter une période d'intervention <span style={{color:'#065FD3',fontSize:'20px'}}>+</span>
              </div>
              <div style={s.expand}>Ajouter des violences <span style={{color:'#065FD3',fontSize:'20px'}}>+</span></div>
              <div style={s.expand}>Ajouter un commentaire <span style={{color:'#065FD3',fontSize:'20px'}}>+</span></div>
            </>
          )}

          {/* ===== ONGLET 5 : DÉMARCHES JURIDIQUES ===== */}
          {tab===4 && (
            <>
              <div style={s.sectionTitle}>Démarches <span style={{color:'#6558F4'}}>Juridiques</span></div>
              <div style={{...s.sectionSub,fontWeight:'600',marginBottom:'20px'}}>Tribunaux, jugements, plaintes, recours, renseignez votre parcours de l'évènement le plus récent à l'évènement le plus ancien.</div>

              {demarches.map((d, i) => (
                <div key={i} style={s.card}>
                  <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:'20px'}}>
                    <div><span style={s.cardTitle}>Tribunal {i+1}</span><span style={{fontSize:'12px',color:'#aaa',marginLeft:'8px'}}>· du plus récent au plus ancien</span></div>
                    {i>0 && <button onClick={()=>setDemarches(dd=>dd.filter((_,idx)=>idx!==i))} style={{background:'none',border:'none',color:'#aaa',cursor:'pointer',fontSize:'18px'}}>🗑</button>}
                  </div>

                  <div style={{marginBottom:'18px'}}>
                    <div style={s.blockLabel}>Je n'ai pas pu</div>
                    <div style={{display:'flex',gap:'12px'}}>
                      {["Déposer plainte","Passer devant le tribunal"].map(o => {
                        const sel = d.na_pas_pu.includes(o);
                        return <label key={o} style={{display:'flex',alignItems:'center',gap:'8px',fontSize:'13px',cursor:'pointer'}}><input type="checkbox" checked={sel} onChange={()=>setDemarche(i,'na_pas_pu',sel?d.na_pas_pu.filter(v=>v!==o):[...d.na_pas_pu,o])} style={{accentColor:'#065FD3'}} />{o}</label>;
                      })}
                    </div>
                  </div>

                  <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'16px',marginBottom:'18px'}}>
                    <div>
                      <div style={s.fieldLabel}>Procédure en cours <span style={{color:'#aaa',fontSize:'11px'}}>(jugement non rendu)</span></div>
                      <RadioGroup options={['Oui','Non']} value={d.procedure_en_cours?'Oui':'Non'} onChange={v=>setDemarche(i,'procedure_en_cours',v==='Oui')} name={`proc${i}`} />
                    </div>
                    <div>
                      <label style={s.fieldLabel}>Si en cours, depuis le</label>
                      <input type="date" style={s.input} value={d.date_procedure} onChange={e=>setDemarche(i,'date_procedure',e.target.value)} />
                    </div>
                  </div>

                  <div style={{display:'grid',gridTemplateColumns:'1fr 1fr 1fr',gap:'16px',marginBottom:'18px'}}>
                    <div><label style={s.fieldLabel}>Nom du tribunal</label><input style={s.input} placeholder="Bobigny" value={d.nom_tribunal} onChange={e=>setDemarche(i,'nom_tribunal',e.target.value)} /></div>
                    <div>
                      <label style={s.fieldLabel}>Département</label>
                      <select style={s.select} value={d.departement} onChange={e=>setDemarche(i,'departement',e.target.value)}>
                        <option value="">Sélectionner…</option>
                        {DEPARTEMENTS.map(dep=><option key={dep} value={dep}>{dep}</option>)}
                      </select>
                    </div>
                    <div>
                      <label style={s.fieldLabel}>Nombre de fois</label>
                      <select style={s.select} value={d.nb_fois} onChange={e=>setDemarche(i,'nb_fois',e.target.value)}>
                        {[1,2,3,4,5,6,7,8,9,10].map(n=><option key={n} value={n}>{n}</option>)}
                      </select>
                    </div>
                  </div>

                  <div style={s.blockLabel}>Étape de la procédure</div>
                  <RadioGrid options={ETAPES_PROCEDURE} value={d.etape} onChange={v=>setDemarche(i,'etape',v)} name={`etape${i}`} cols={4} />

                  <div style={s.blockLabel}>Votre avocat.e vous a déconseillé.e</div>
                  <div style={{display:'flex',gap:'10px',marginBottom:'20px'}}>
                    {['FAIRE APPEL','PORTER PLAINTE'].map(o => {
                      const sel = d.avocat_deconseille.includes(o);
                      return (
                        <div key={o} style={s.checkCard(sel)} onClick={()=>setDemarche(i,'avocat_deconseille',sel?d.avocat_deconseille.filter(v=>v!==o):[...d.avocat_deconseille,o])}>
                          <input type="checkbox" checked={sel} onChange={()=>{}} style={{accentColor:'#065FD3'}} />
                          <span style={s.radioCardText}>{o}</span>
                        </div>
                      );
                    })}
                  </div>

                  <div style={s.blockLabel}>Cette procédure à été engagée à l'initiative de</div>
                  <RadioGroup options={["Moi même","L'autre parent","L'état","Autre"]} value={d.initiative} onChange={v=>setDemarche(i,'initiative',v)} name={`init${i}`} />
                </div>
              ))}

              <div style={s.expand} onClick={()=>setDemarches(d=>[...d,newDemarche()])}>
                Ajouter un tribunal <span style={{color:'#065FD3',fontSize:'20px'}}>+</span>
              </div>
              <div style={s.expand}>Ajouter une plainte <span style={{color:'#065FD3',fontSize:'20px'}}>+</span></div>
              <div style={s.expand}>Ajouter un commentaire <span style={{color:'#065FD3',fontSize:'20px'}}>+</span></div>
            </>
          )}

          {/* ===== ONGLET 6 : PARCOURS INSTITUTIONNEL ===== */}
          {tab===5 && (
            <div style={{textAlign:'center',padding:'60px 20px',color:'#aaa'}}>
              <div style={{fontSize:'32px',marginBottom:'16px'}}>🚧</div>
              <div style={{fontSize:'16px',fontWeight:'600',marginBottom:'8px',color:'#19232F'}}>Parcours institutionnel</div>
              <div style={{fontSize:'13px'}}>Cette section est en cours de conception par l'équipe design.</div>
            </div>
          )}

          {isLoggedIn && (
            <button style={s.saveBtn} onClick={save} disabled={saving}>
              {saving ? 'Sauvegarde…' : saveMsg || 'SAUVEGARDER'}
            </button>
          )}

          <div style={s.navRow}>
            {isLoggedIn && <button style={s.navBtn} onClick={()=>setTab(t=>Math.max(0,t-1))} disabled={tab===0}>← Revenir à l'étape précédente</button>}
            {isLoggedIn && (tab < TABS.length-1
              ? <button style={s.navBtnNext} onClick={()=>setTab(t=>t+1)}>ÉTAPE SUIVANTE →</button>
              : <button style={{...s.navBtnNext,background:'#065FD3',color:'#fff',border:'none'}} onClick={submit}>ENVOYER MA FICHE →</button>
            )}
          </div>
        </div>

        <div style={s.footer}>
          <div style={s.footerText}>Finalement je crée mon compte utilisatrice!</div>
          <button style={s.footerBtn} onClick={onNavigate}>CRÉER SON COMPTE</button>
        </div>
      </div>
    </div>
  );
}

function ViolencesBlock({ g, i, setGarde }) {
  const s2 = {
    blockLabel: {fontSize:'13px',fontWeight:'700',color:'#19232F',marginBottom:'14px'},
    input: {width:'100%',border:'1px solid #ddd',borderRadius:'8px',padding:'9px 13px',fontSize:'13px',color:'#19232F'},
    checkCard: (sel) => ({border:`1px solid ${sel?'#065FD3':'#ddd'}`,borderRadius:'10px',padding:'12px 10px',cursor:'pointer',display:'flex',flexDirection:'column',alignItems:'flex-start',gap:'8px',background:sel?'#EEF4FF':'#fff'}),
    ri: (sel) => ({border:`1px solid ${sel?'#065FD3':'#ddd'}`,borderRadius:'8px',padding:'9px 18px',cursor:'pointer',display:'flex',alignItems:'center',gap:'8px',fontSize:'13px',color:sel?'#065FD3':'#19232F',fontWeight:'500',background:sel?'#EEF4FF':'#fff'}),
  };
  const VIOLENCES_ENFANTS = ['VIOLS','AGRESSION SEXUELLES','VIOLENCES PHYSIQUES','VIOLENCES PSYCHOLOGIQUES (Contrôle coercitif, abus psychologiques, insultes...)','NÉGLIGENCES & PRIVATIONS','VIOLENCES INSTITUTIONNELLES','PLACEMENT ASE ILLÉGAL','PROSTITUTION VIA L\'ASE'];
  const VIOLENCES_PP = ['VIOLS','AGRESSION SEXUELLES','VIOLENCES PHYSIQUES','VIOLENCES PSYCHOLOGIQUES (Contrôle coercitif, abus psychologiques, insultes...)','VIOLENCES INSTITUTIONNELLES','VIOLENCES ÉCONOMIQUES (Rétention, irrégularités de la pension alimentaire...)','INERTIE (Opposition ou absence de réponse)'];

  return (
    <>
      <div style={{...s2.blockLabel,marginTop:'16px'}}>Violences subies actuellement <span style={{color:'#aaa',fontSize:'12px',fontWeight:'400'}}>· Par votre/vos enfant.s</span></div>
      <div style={{display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:'10px',marginBottom:'14px'}}>
        {VIOLENCES_ENFANTS.map(o => {
          const sel = (g.violences_enfants||[]).includes(o);
          return <div key={o} style={s2.checkCard(sel)} onClick={()=>setGarde(i,'violences_enfants',sel?(g.violences_enfants||[]).filter(v=>v!==o):[...(g.violences_enfants||[]),o])}><input type="checkbox" checked={sel} onChange={()=>{}} style={{accentColor:'#065FD3'}} /><span style={{fontSize:'11px',fontWeight:'600',color:'#19232F',lineHeight:'1.3'}}>{o}</span></div>;
        })}
      </div>
      <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'16px',marginBottom:'16px'}}>
        <div>
          <div style={s2.blockLabel}>Dépôt de plainte (pour votre/ vos enfants)</div>
          <div style={{display:'flex',gap:'10px'}}>
            {['Oui','Non'].map(o => <div key={o} style={s2.ri(g.depot_plainte_enfants===(o==='Oui'))} onClick={()=>setGarde(i,'depot_plainte_enfants',o==='Oui')}><input type="radio" checked={g.depot_plainte_enfants===(o==='Oui')} onChange={()=>{}} style={{accentColor:'#065FD3'}} />{o}</div>)}
          </div>
        </div>
        <div><label style={s2.blockLabel}>Date des révélations</label><input type="date" style={s2.input} value={g.date_revelations||''} onChange={e=>setGarde(i,'date_revelations',e.target.value)} /></div>
      </div>
      <div style={{...s2.blockLabel,marginTop:'8px'}}>Violences subies actuellement <span style={{color:'#aaa',fontSize:'12px',fontWeight:'400'}}>· Par vous</span></div>
      <div style={{display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:'10px',marginBottom:'14px'}}>
        {VIOLENCES_PP.map(o => {
          const sel = (g.violences_pp||[]).includes(o);
          return <div key={o} style={s2.checkCard(sel)} onClick={()=>setGarde(i,'violences_pp',sel?(g.violences_pp||[]).filter(v=>v!==o):[...(g.violences_pp||[]),o])}><input type="checkbox" checked={sel} onChange={()=>{}} style={{accentColor:'#065FD3'}} /><span style={{fontSize:'11px',fontWeight:'600',color:'#19232F',lineHeight:'1.3'}}>{o}</span></div>;
        })}
      </div>
      <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'16px'}}>
        <div>
          <div style={s2.blockLabel}>Dépôt de plainte (pour vous)</div>
          <div style={{display:'flex',gap:'10px'}}>
            {['Oui','Non'].map(o => <div key={o} style={s2.ri((g.depot_plainte_pp!==false)===(o==='Oui'))} onClick={()=>setGarde(i,'depot_plainte_pp',o==='Oui')}><input type="radio" checked={(g.depot_plainte_pp!==false)===(o==='Oui')} onChange={()=>{}} style={{accentColor:'#065FD3'}} />{o}</div>)}
          </div>
        </div>
        <div><label style={s2.blockLabel}>Date des révélations</label><input type="date" style={s2.input} value={g.date_revelations_pp||''} onChange={e=>setGarde(i,'date_revelations_pp',e.target.value)} /></div>
      </div>
    </>
  );
}
